import { WorkStatus } from '@kaiizen/kai-scan-template-system';

import { COLORS2 } from '../../../Styles';

const DEFAULT_SECONDARY_COLOR = COLORS2.alwaysDark.darkGray;
const DEFAULT_PRIMARY_COLOR = COLORS2.alwaysDark.yellow;
type IconProps = {
  secondary?: string;
  primary?: string;
};
const DEFAULT_ICON_PROPS: IconProps = {
  secondary: DEFAULT_SECONDARY_COLOR,
  primary: DEFAULT_PRIMARY_COLOR,
};
const DEFAULT_BLACK_ICON_PROPS: IconProps = {
  secondary: COLORS2.alwaysDark.black,
  primary: COLORS2.alwaysDark.black,
};

export const TaskNotStartedIcon = (props: IconProps) => {
  const { secondary = DEFAULT_SECONDARY_COLOR } = props;
  return (
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='11' cy='11' r='6.5' stroke={secondary} />
    </svg>
  );
};

export const TaskNeedsReworkIcon = (props: IconProps) => {
  const { secondary = DEFAULT_SECONDARY_COLOR, primary = DEFAULT_PRIMARY_COLOR } = props;
  return (
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1_289)'>
        <path
          d='M9.96872 4.58705C8.30205 4.72886 6.74125 5.4628 5.56896 6.65596C4.39667 7.84912 3.69038 9.42263 3.578 11.0915C3.46562 12.7605 3.95457 14.4144 4.95631 15.754C5.95805 17.0936 7.40635 18.0301 9.03896 18.3941C10.6716 18.7581 12.3806 18.5254 13.8564 17.7382C15.3323 16.9511 16.4776 15.6614 17.0847 14.1028C17.6919 12.5442 17.7209 10.8197 17.1664 9.24157C16.8756 8.41385 16.4344 7.6551 15.8716 7'
          stroke={primary}
        />
        <path
          d='M13.8442 5.00001L14.9706 10.6626L19.3113 6.85578L13.8442 5.00001ZM16.8113 8.38327L16.3494 8.57461C16.3948 8.68418 16.4373 8.79523 16.4768 8.90764L16.9485 8.74191L17.4202 8.57618C17.3747 8.44648 17.3256 8.31836 17.2733 8.19193L16.8113 8.38327Z'
          fill={primary}
        />
      </g>
      <defs>
        <clipPath id='clip0_1_289'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TaskInProgressIcon = (props: IconProps) => {
  const { primary = DEFAULT_PRIMARY_COLOR, secondary = DEFAULT_SECONDARY_COLOR } = props;
  return (
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4 11C4 14.866 7.13401 18 11 18L11 4C7.13401 4 4 7.13401 4 11Z' fill={primary} />
      <circle cx='11' cy='11' r='6.5' stroke={secondary} />
    </svg>
  );
};

export const TaskCompletedIcon = (props: IconProps) => {
  const { primary = DEFAULT_PRIMARY_COLOR, secondary = DEFAULT_SECONDARY_COLOR } = props;
  return (
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='11' cy='11' r='6.5' stroke={secondary} />
      <path d='M8 10.421L11 13L18 5' stroke={primary} strokeWidth='1.57881' strokeLinejoin='round' />
    </svg>
  );
};

export const WorkStatusIcon = ({ status, black }: { status: WorkStatus; black?: boolean }) => {
  switch (status) {
    case 'notStarted':
      return <TaskNotStartedIcon {...(black ? DEFAULT_BLACK_ICON_PROPS : DEFAULT_ICON_PROPS)} />;
    case 'needsRework':
      return <TaskNeedsReworkIcon {...(black ? DEFAULT_BLACK_ICON_PROPS : DEFAULT_ICON_PROPS)} />;
    case 'inProgress':
      return <TaskInProgressIcon {...(black ? DEFAULT_BLACK_ICON_PROPS : DEFAULT_ICON_PROPS)} />;
    case 'completed':
      return <TaskCompletedIcon {...(black ? DEFAULT_BLACK_ICON_PROPS : DEFAULT_ICON_PROPS)} />;
  }
};

export const TaskIcons = ({ workStatus }: { workStatus: WorkStatus }) => {
  switch (workStatus) {
    case 'notStarted':
      return <TaskNotStartedIcon />;
    case 'needsRework':
      return <TaskNeedsReworkIcon />;
    case 'inProgress':
      return <TaskInProgressIcon />;
    case 'completed':
      return <TaskCompletedIcon />;
  }
};
